import { Dictionary } from "@insite/client-framework/Common/Types";
import { request } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export function patch<T extends BaseModel>(
    endpoint: string,
    model: Partial<T> | T,
    queryStringParameters: Dictionary<any> = {},
) {
    let queryString = "";

    for (const key in queryStringParameters) {
        if (key !== "additionalQueryStringParameters" && queryStringParameters[key] !== undefined) {
            if (key !== "expand" && key !== "exclude" && Array.isArray(queryStringParameters[key])) {
                // WebApi requires arrays to be split into individual query string values
                queryStringParameters[key].forEach((p: string) => {
                    queryString += `${key}=${encodeURIComponent(p)}&`;
                });
            } else {
                queryString += `${key}=${encodeURIComponent(queryStringParameters[key])}&`;
            }
        }
    }

    if (queryString !== "") {
        queryString = (endpoint.indexOf("?") < 0 ? "?" : "&") + queryString.substring(0, queryString.length - 1);
    }

    return request<T>(endpoint + queryString, "PATCH", { "Content-Type": "application/json" }, JSON.stringify(model));
}
